import PropTypes from 'prop-types';
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "../../common/components/DataTable";
import { SettingsDisplay } from "../../common/components/SettingsPanels";
import useCredentials from "../../common/hooks/credentialsHook";
import useNetwork from "../../common/hooks/networkHook";
import { addStdReply, canCreateStdReply, canRemoveStdReply, removeStdReply, useStdReplies } from "../../reducers/stdReplySlice";

const defaultSort = ['kind'];

const StandardReplies = ({ uuid, label, onClose }) => {
    const { t } = useTranslation();
    const replies = useStdReplies();
    const network = useNetwork();
    const credentials = useCredentials();

    let displayReplies = useMemo(() => replies, [replies]);

    const columns =  useMemo(() => [{field: 'reply', title: t('reply_one'), editable: true, required: true, type: 'text'}, 
                                    {field: 'kind', title: t('kind'), label: t('kind'), requried: true, editable: true, type: 'option', wildcard: t('allWildcard'), key: 'label', value: 'value', options: [{ label: t('sms'), value: 'SMS' }, { label: t('email'), value: 'Email' }, { label: t('voice'), value: 'Voice' }]}], [t])
    
    return <SettingsDisplay uuid={uuid} title={label} onClose={onClose}>
        <DataTable columns={columns} showFilter={true} csvFilename={t('stdReplies') + '.csv'} disableAdd={!canCreateStdReply(credentials)} disableRemove={!canRemoveStdReply(credentials)} defaultSort={defaultSort} value={displayReplies} onAdd={r => addStdReply(network, r)} onRemove={r => removeStdReply(network, r.id)}></DataTable>
    </SettingsDisplay>
}

StandardReplies.propTypes = {
    /**
     * ID to identify the settings status entry
     */
    uuid: PropTypes.string.isRequired,
    /**
     * Label for the screen
     */
    label: PropTypes.string.isRequired,
    /**
     * Function to call when the screen is closed
     */
    onClose: PropTypes.func
}

export default StandardReplies;